




























































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RequestButton from '@/components/RequestButton'

settings = 
  name: 'CompleteAdvanceStep'
  vue:
    mixins: [WizardService.step()]
    components: { RequestButton }
    computed: 
      canComplete: -> return true
      isFinalized: -> @wizard.prime.advance.brand_finalized_info
    methods:
      toggleFinalized: -> 
        @wizard.prime.advance.brand_finalized_info = !@wizard.prime.advance.brand_finalized_info
        @saveStep()
      validateStep: ->  return true
      saveFields: -> advance : ['brand_finalized_info']


export default VueOptions.vue settings
